import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import GamesCarousel from '../components/GamesCarousel';
import Team from '../components/Team';
import About from '../components/About';
import Discord from '../components/Discord';
import Contact from '../components/Contact';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle hash navigation when component mounts or hash changes
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // If no hash, scroll to top
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  return (
    <div>
      <Hero />
      <GamesCarousel />
      <Team />
      <About />
      <Discord />
      <Contact />
    </div>
  );
};

export default Home;